import API from "../utils/api";

export const getPartnersPromotionsDataApi = async (data) => {
  const response = await API.get("order/promotion", { params: data });
  return { response };
};

export const editPartnersPromotionsApi = async (id, data) => {
  const response = await API.get(`order/promotion/${id}/edit`, { params: data });
  return { response };
};

export const storePartnerPromotionApi = async (data) => {
  const response = await API.post("order/promotion", data);
  return { response };
};

export const updatePartnerPromotionApi = async (data) => {
  const response = await API.put(`order/promotion/${data.id}`, data.promotionData);
  return { response };
};

export const getVariantProductsApi = async (data) => {
  const response = await API.get("order/promotion/product-list", { params: data });
  return { response };
};

export const viewPartnerPromotionApi = async (id, data) => {
  const response = await API.get(`order/promotion/${id}`, { params: data });
  return { response };
};

export const getPartnerPromotionSettingsApi = async () => {
  const response = await API.get(`order/promotion/setting`);
  return { response };
};

export const deletePartnerPromotionApi = async (id) => {
  const response = await API.delete(`order/promotion/${id}`);
  return { response };
};

export const exportDifferenceDiscountReportApi = async (data) => {
    const response = await API.get('order/promotion/difference-discount/export', {
        params: data,
    });
    return { response };
};

export const getDifferenceDiscountApi = async (data) => {
  const response = await API.get("order/promotion/difference-discount", { params: data });
  return { response };
};

export const approveDiffDiscountApi = async (data) => {
  const response = await API.post("order/promotion/difference-discount/approve", data);
  return { response };
};

export const declineDiffDiscountApi = async (data) => {
  const response = await API.post("order/promotion/difference-discount/decline", data);
  return { response };
};